<template>
  <div class="flex flex-col" data-cy="team-name-cell">
    <span class="font-medium">
      {{ member.fullName || member.email }}
      <span
        v-if="isSelf"
        class="ml-1 align-middle text-[10px] font-semibold uppercase tracking-wide text-primary"
        data-cy="team-you-tag"
      >
        {{ $t("team.you") }}
      </span>
    </span>
    <span
      v-if="member.fullName && member.email"
      class="text-xs text-muted-foreground"
    >
      {{ member.email }}
    </span>
  </div>
</template>

<script setup lang="ts">
import type { ITeamMember } from "@/interfaces/responses/team";

defineProps<{
  member: ITeamMember;
  /** Whether this row is the signed-in user. */
  isSelf: boolean;
}>();
</script>
